/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentDefinition extends models.BillingCommitmentBase {
    getFixupPrototypeFunction() { return BillingCommitmentDefinition.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentDefinition>): BillingCommitmentDefinition {
        let obj = Object.assign(new BillingCommitmentDefinition(), model);
        BillingCommitmentDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentDefinition>): BillingCommitmentDefinition {
        if (!model) return null;
        return BillingCommitmentDefinition.newInstance(<BillingCommitmentDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentDefinition) {
        if (!obj) return;

        models.BillingCommitmentDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentDefinition): boolean {
        if (models.BillingCommitmentBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingCommitmentDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.commitment_amount === undefined) {
            this.commitment_amount = 0;
        }
        if (typeof this.purchased_date === "string") {
            this.purchased_date = new Date(<string><any>this.purchased_date);
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.expiry_date === "string") {
            this.expiry_date = new Date(<string><any>this.expiry_date);
        }
    }

    /**
     * Billing Commitment Name
     */
    name: string;

    /**
     * Billing Commitment Status
     */
    status: models.BillingCommitmentStatus;

    /**
     * Billing Commitment Amount
     */
    commitment_amount: number;

    /**
     * Purchased Date of Billing commitment
     */
    purchased_date: Date;

    /**
     * Start Date of Billing commitment
     */
    start_date: Date;

    /**
     * Expiry Date of Billing commitment
     */
    expiry_date: Date;

}
